export function getPageTitle(metaElementData = []) {
  if (!Array.isArray(metaElementData)) {
    return;
  }
  if (metaElementData && metaElementData.length === 0) {
    return;
  }
  return metaElementData.reduce((acc, metaItem = {}) => {
    if (metaItem.name === 'pageTitle' && metaItem.content) {
      acc = metaItem.content;
    }
    return acc;
  }, undefined);
}

export function getPageDescription(metaElementData = []) {
  if (!Array.isArray(metaElementData)) {
    return;
  }
  if (metaElementData && metaElementData.length === 0) {
    return;
  }
  return metaElementData.reduce((acc, metaItem = {}) => {
    if (metaItem.name === 'description' && metaItem.content) {
      acc = metaItem.content;
    }
    return acc;
  }, undefined);
}

export function getCuratedPageDescription(metaElementData = []) {
  if (!Array.isArray(metaElementData)) {
    return;
  }
  if (metaElementData && metaElementData.length === 0) {
    return;
  }
  return metaElementData.reduce((acc, metaItem = {}) => {
    if (metaItem.name === 'metaDescription' && metaItem.content) {
      acc = metaItem.content;
    }
    return acc;
  }, undefined);
}

export function getCategoryPageDescription(metaElementData = []) {
  if (!Array.isArray(metaElementData)) {
    return;
  }
  if (metaElementData && metaElementData.length === 0) {
    return;
  }
  return metaElementData.reduce((acc, metaItem = {}) => {
    if (metaItem.name === 'pageDescription' && metaItem.content) {
      acc = metaItem.content;
    }
    return acc;
  }, undefined);
}

export function getPageKeywords(metaElementData = []) {
  if (!Array.isArray(metaElementData)) {
    return;
  }
  if (metaElementData && metaElementData.length === 0) {
    return;
  }
  return metaElementData.reduce((acc, metaItem = {}) => {
    if (metaItem.name === 'keywords' && metaItem.content) {
      acc = metaItem.content;
    }
    return acc;
  }, undefined);
}

export function getSeoPlpMetadata(
  metaKeywords = '',
  categoryNameMeta = '',
  filterValueMeta = '',
  brandNameMeta = ''
) {
  let newMetaKeywords = metaKeywords;
  if (!metaKeywords) {
    return '';
  }

  newMetaKeywords = newMetaKeywords.replace(/\${categoryName}/g, categoryNameMeta || '');
  newMetaKeywords = newMetaKeywords.replace(/\${filterValue}/g, filterValueMeta || '');
  newMetaKeywords = newMetaKeywords.replace(/\${brandName}/g, brandNameMeta || '');

  return newMetaKeywords;
}

export function getSeoFooterData(metaElementData = [], type, isRuntimeBanners = false) {
  if (isRuntimeBanners === 'ON') {
    return metaElementData[type];
  }
  if (!Array.isArray(metaElementData)) {
    return;
  }
  if (metaElementData && metaElementData.length === 0) {
    return;
  }
  return metaElementData.reduce((acc, metaItem = {}) => {
    if (metaItem.name == 'bottomdescription' && type == 'bottomDesc' && metaItem.content) {
      acc = metaItem.content;
    } else if (metaItem.name === 'topdescription' && type == 'topDesc' && metaItem.content) {
      acc = metaItem.content;
    } else if (metaItem.name === 'topSearches' && type == 'searches' && metaItem.content) {
      acc = metaItem.content;
    } else if (metaItem.name === 'topBrands' && type == 'brands' && metaItem.content) {
      acc = metaItem.content;
    }
    return acc;
  }, undefined);
}
